export default __webpack_public_path__ + "static/media/navbar_account_icon.65b3f53a.svg";